class PopoutCart extends HTMLElement {
  
  constructor(){
    super();
    this.lastActiveElement = null;
    this.build();
  }

  build() {
    fetch(window.Shopify.routes.root + '?section_id=stmt-popout-cart')
    .then((res) => {
      return res.text();
    })
    .then((section) => {
      const parser = new DOMParser;
      const popoutCartHtml = parser.parseFromString(section, "text/html");
      const popoutCartSource = popoutCartHtml.querySelector('.js-popout-cart-inner');
      const popoutCartTarget = document.querySelector('.js-popout-cart-items');
    
      if (popoutCartSource && popoutCartTarget) {
        popoutCartTarget.innerHTML = popoutCartSource.outerHTML;
      }

      document.dispatchEvent(new CustomEvent('asyncSlider:ready'));

      this.listeners();
      this.bindEmptyCloseEvents();

      if (sessionStorage.getItem('showPopoutCart')) {
        this.showCart();
        sessionStorage.removeItem('showPopoutCart');
      }
    })
    .catch((e) => {
      console.error(e);
    })
  }

  listeners(){
    const closeButtons = document.querySelectorAll('.js-popout-cart-close');
    const popoutCart = this.querySelector('.js-popout-cart');
    const shade = this.querySelector('.js-shade');

    let crossSellsWheelThrottle = null;

    this.addEventListener('wheel', (e) => {
      const slider = this.querySelector('#popoutCartCrossSellsSlider');
      if (!slider || !slider.contains(e.target)) return;
      if (Math.abs(e.deltaX) <= Math.abs(e.deltaY)) return;

      e.preventDefault();

      if (crossSellsWheelThrottle) return;
      crossSellsWheelThrottle = setTimeout(() => { crossSellsWheelThrottle = null; }, 350);

      if (e.deltaX > 0) {
        slider.querySelector('.splide__arrow--next')?.click();
      } else {
        slider.querySelector('.splide__arrow--prev')?.click();
      }
    }, { passive: false });

    document.addEventListener('popout-cart:show', () => {
      this.showCart();
    });

    document.addEventListener('popout-cart:close', () => {
      this.closeCart();
    });

    closeButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeCart();
      });
    });

    if (shade) {   
      shade.addEventListener('click', () => {
        this.closeCart();
      });
    }

    document.addEventListener('keydown', (e) => {
      if (!document.body.classList.contains('popout-cart-active')) return;

      if (e.key === 'Escape') {
        this.closeCart();
      }

      if (e.key === 'Tab') {
        this.trapFocus(e);
      }
    });

    document.addEventListener('focusin', (e) => {
      if (!document.body.classList.contains('popout-cart-active')) return;
      if (!this.contains(e.target)) {
        this.focusFirstElement();
      }
    });

    document.addEventListener('cart:requestStart', () => {
      if (popoutCart) {
        popoutCart.scrollTop = 0;
      }
    });

    document.addEventListener('cart:requestComplete', (e) => {
      this.paintPopoutCart(e);
    });

    document.addEventListener('cart:updated', () => {
      this.bindEmptyCloseEvents();

      if (document.body.classList.contains('popout-cart-active')) {
        this.focusFirstElement();
      }
    });
  }

  bindEmptyCloseEvents() {
    const cartEmptyButtons = this.querySelectorAll('.js-popout-cart-empty');

    cartEmptyButtons.forEach((el) => {
      el.addEventListener('click', () => {
        this.closeCart();
      });
    })
  }

  getFocusableElements() {
    return Array.from(this.querySelectorAll(`
      a[href],
      area[href],
      input:not([disabled]):not([type="hidden"]),
      select:not([disabled]),
      textarea:not([disabled]),
      button:not([disabled]),
      iframe,
      object,
      embed,
      [contenteditable],
      [tabindex]:not([tabindex="-1"])
    `)).filter((el) => {
      return el.offsetParent !== null;
    });
  }

  focusFirstElement() {
    const focusableElements = this.getFocusableElements();

    if (focusableElements.length) {
      focusableElements[0].focus();
    }
  }

  trapFocus(e) {
    const focusableElements = this.getFocusableElements();

    if (!focusableElements.length) return;

    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];
    const activeElement = document.activeElement;

    if (e.shiftKey) {
      if (activeElement === firstElement || !this.contains(activeElement)) {
        e.preventDefault();
        lastElement.focus();
      }
    } else {
      if (activeElement === lastElement) {
        e.preventDefault();
        firstElement.focus();
      }
    }
  }

  showCart() {
    const body = document.querySelector('body');

    this.lastActiveElement = document.activeElement;
    body.classList.add('popout-cart-active');

    setTimeout(() => {
      this.focusFirstElement();
    }, 0);
  }

  closeCart() {
    const body = document.querySelector('body');

    body.classList.remove('popout-cart-active');

    if (this.lastActiveElement && typeof this.lastActiveElement.focus === 'function') {
      this.lastActiveElement.focus();
    }
  }

  paintPopoutCart(e) {
    if (e.detail.data.sections) {
      const popoutCartSection = e.detail.data.sections['stmt-popout-cart'];
      const popoutCartItems = document.querySelector('.js-popout-cart-items');
      
      if (popoutCartSection && popoutCartItems) {
        popoutCartItems.innerHTML = popoutCartSection;
      }

      document.dispatchEvent(new CustomEvent('asyncSlider:ready'));
    }

    document.dispatchEvent(new CustomEvent('cart:updated'));
  }
}

customElements.define('popout-cart', PopoutCart);
